import { UsersTable } from './UsersTable.jsx';

export default UsersTable;
